import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_warn",
  "use": "icon-map_warn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_warn\">\n<g id=\"icon-map_warn_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 2 1.027344 C -4.863281 8 5.808594 23 13.972656 15 C 20.324219 8.621094 9.277344 -6.21875 2 1.027344 M 7 10 L 9 10 C 9.199219 9 10 5.042969 12 7.085938 C 16.566406 11.648438 8.566406 15.710938 4.601563 13.398438 C -3.398438 8.726563 9.742188 -2.246094 7.941406 5.457031 C 7.574219 7.03125 7.203125 8.382813 7 10 M 12 3 L 11 4 L 12 3 M 7.5 11.5 C 6.871094 12.128906 7.871094 13.128906 8.5 12.5 C 9 12 8 11 7.5 11.5 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_warn.svg
// module id = bmW+
// module chunks = 24